import axios from "axios";

const useRequest = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
});

export default useRequest;